import { Anchor } from "~/components/Anchor";
import { MediaCitation } from "../../types";
import { ImageLoader } from "~/components/ImageLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRight } from "@fortawesome/pro-regular-svg-icons";
import { MediaCitationsUserEvents } from "~/modules/analytics/events/media_citations";
import { formatCitationDate } from "./formatCitationDate";
import { CITATION_FALLBACK_IMAGE_URL } from "./consts";
import { RWA_COIN_ICON } from "~/consts";

// // // //

export function CitationListRow(props: {
    citation: MediaCitation;
    imageLoading?: "eager" | "lazy";
}) {
    const { citation, imageLoading } = props;

    return (
        <Anchor
            href={citation.url}
            analyticsLabel={MediaCitationsUserEvents.ClickCitationListRow}
            analyticsEventProperties={{
                citationTitle: citation.title,
                publisherName: citation.publisher.name,
            }}
            className="grid grid-cols-[72px_minmax(0,1fr)_auto] items-center gap-4 border-b px-4.5 py-3.5 transition-colors last:border-b-0 hover:bg-blue-50"
            openInNewTab
        >
            <div className="flex h-13 items-center justify-center overflow-hidden rounded-md bg-accent">
                <ImageLoader
                    src={citation.image_url}
                    alt={citation.title}
                    className="h-full w-full object-cover"
                    fallbackSrc={CITATION_FALLBACK_IMAGE_URL}
                    loading={imageLoading}
                />
            </div>

            <div className="flex min-w-0 flex-col gap-1">
                <div className="flex items-center gap-1.5">
                    <ImageLoader
                        src={citation.publisher.icon_url || RWA_COIN_ICON}
                        alt={`${citation.publisher.name} icon`}
                        className="size-3 shrink-0 rounded object-contain"
                        fallbackSrc={RWA_COIN_ICON}
                        loading={imageLoading}
                    />
                    <span className="truncate text-xs text-muted-foreground">
                        {citation.publisher.name}
                    </span>
                </div>
                <span className="truncate text-sm font-semibold text-foreground">
                    {citation.title}
                </span>
            </div>

            <div className="flex shrink-0 flex-col items-end gap-1">
                <div className="flex flex-col items-center gap-2.5">
                    <span className="flex items-center gap-1 text-xs font-semibold text-primary">
                        Read Article
                        <FontAwesomeIcon
                            icon={faArrowUpRight}
                            className="h-2.5 w-2.5"
                        />
                    </span>
                    <span className="hidden text-xs font-light text-muted-foreground tabular-nums sm:block">
                        {formatCitationDate(citation.published_date)}
                    </span>
                </div>
            </div>
        </Anchor>
    );
}
